import { toast } from 'react-toastify';

export const MAX_IMAGE_SIZE_MB = 10;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024; // 10,485,760 bytes

/**
 * Triggers the attractive file size limit popup modal and notification.
 * @param {File|Object} file
 * @param {number} limitMB
 */
export const triggerFileSizeLimitAlert = (file, limitMB = MAX_IMAGE_SIZE_MB) => {
  const fileName = file?.name || 'Selected file';
  const sizeMB = file?.size ? (file.size / (1024 * 1024)).toFixed(2) : null;

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('file-size-limit-exceeded', {
        detail: {
          fileName,
          sizeMB,
          limitMB
        }
      })
    );
  }

  // Complementary toast notification
  toast.error(`File size limit exceeded: "${fileName}" is ${sizeMB ? sizeMB + ' MB' : 'too large'}. Max allowed size is ${limitMB} MB.`);
};

/**
 * Validates a file's size against limitMB.
 * If exceeded, displays the attractive popup, clears the input if provided, and returns false.
 * @param {File} file
 * @param {Event|HTMLInputElement|null} inputOrEvent
 * @param {number} limitMB
 * @returns {boolean} true if valid, false if exceeded
 */
export const validateImageFile = (file, inputOrEvent = null, limitMB = MAX_IMAGE_SIZE_MB) => {
  if (!file) return true;

  const maxBytes = limitMB * 1024 * 1024;
  if (file.size > maxBytes) {
    if (inputOrEvent) {
      if (inputOrEvent.target && 'value' in inputOrEvent.target) {
        inputOrEvent.target.value = '';
      } else if ('value' in inputOrEvent) {
        inputOrEvent.value = '';
      }
    }
    triggerFileSizeLimitAlert(file, limitMB);
    return false;
  }

  return true;
};
